import { FC } from 'react'
import { Tag } from '@common/tags/tag.ts';

import { Button } from '@ui/buttons/button.tsx';
import { Trans } from '@ui/i18n/trans.tsx';

import { FavoriteIcon } from '@ui/icons/material/Favorite.tsx';
import { FavoriteBorderIcon } from '@ui/icons/material/FavoriteBorder.tsx';

import { MicIcon } from '@ui/icons/material/Mic';
import { Link } from 'react-router'

import { Loader2Icon } from 'lucide-react'
import { useTagFollow } from '@player/custom/hooks/use-tag-follow.ts';

export interface ExtendTag extends Tag {
    model_type: 'tag'
    albums_count: number
    artists_count: number
    tracks_count: number
}

export const TagItem: FC<ExtendTag> = (tag) => {
    const { isLoading, isLiked, toggleLike } = useTagFollow(tag.id)

    return (
        <div className="flex items-center gap-20 py-5 pl-5 pr-10 border-b hover:bg-hover last-of-type:border-0 transition-all duration-500">
            <Link to={`/tag/${tag.name}`} className="w-50 h-50 flex items-center justify-center bg-hover rounded">
                <MicIcon className="text-muted w-25 h-25" />
            </Link>

            <div>
                <Link to={`/tag/${tag.name}`}>{tag.display_name} </Link>
                <div className="flex items-center text-muted text-xs gap-10">
                    <div>
                        <strong className="text-main">{tag.albums_count}</strong> <Trans message="album(s)" />
                    </div>
                    •
                    <div>
                        <strong className="text-main">{tag.tracks_count}</strong> <Trans message="track(s)" />
                    </div>
                </div>
            </div>

            <Button
                startIcon={isLoading ? <Loader2Icon className="w-24 h-24 animate-spin" /> : isLiked ? <FavoriteIcon size="w-24 h-24" className="text-primary" /> : <FavoriteBorderIcon size="w-24 h-24" />}
                variant="outline"
                radius="xl"
                className="ml-auto rounded"
                onClick={() => toggleLike()}
                disabled={isLoading}
            >
                <Trans message={isLiked ? 'Unfollow' : 'Follow'} />
            </Button>
        </div>
    )
}
